export class DustAnimation {
    dustContainer: HTMLElement;
    maxSpeed = 10;
    minSpeed = 16;
    constructor(dustContainer?: HTMLElement) {
        if (dustContainer) {
            this.dustContainer = dustContainer;
        } else {
            this.dustContainer = document.createElement("div");
        }
        this.dustContainer.classList.add("dustContainer");
    }

    get element() {
        return this.dustContainer;
    }

    addDust() {
        const dust = document.createElement("div");
        dust.className = "dust";
        dust.style.left = Math.random() * 100 + "%";
        dust.style.top = Math.random() * 100 + "%";
        dust.style.animationDuration = this.maxSpeed + Math.random() * (this.minSpeed - this.maxSpeed) + "s";
        dust.style.animationDelay = -Math.random() * this.minSpeed + "s";
        this.dustContainer.appendChild(dust);
    }

    setVisible(visible: boolean) {
        if (visible) {
            this.dustContainer.style.display = "block";
        } else {
            this.dustContainer.style.display = "none";
        }
    }

    addDusts(number: number) {
        for (let i = 0; i < number; i++) {
            this.addDust();
        }
    }
}
